import * as React from 'react'
import { VariablesObj, CompanyT, VariablesT } from "../../../../types/Company";

import { VariableDocumentT, getVariableValue } from './DocumentVariables';
import * as _ from 'lodash'

import { copyObject, phoneFormat } from '../../../../utils';
import { reflectorLabelsEstimate } from './Estimate/EstimateLineItem';

import { ClientT } from '../../../../types/Users';
import { AgreementT, DocumentT, EstimateLineItemT, InvoiceLineItemT, JobStatusTStrings, JobT, JobTypeTStrings } from '../../../../types/Job';
import { prepareCupeSheetForPrint, sortFinancialLineItems, sortItemsCupeSheetByCategory, sumFinancialLineItems } from '../JobUtils';
import { CupeSheetPrintT } from '../../../../types/CargoT';
import { numberToCurrency } from '../../../../utils/utilsT';


export interface ConfigDocumentsT {
  name: string
  title: string
  display: Array<{ jobType: JobTypeTStrings, state: Array<string>, excludeState?: Array<string> }>
  displayWithJobStatus?: Array<JobStatusTStrings>
  variables: Array<VariableDocumentT>
  defaultAgreement?: AgreementT
  template?: string
  optionsTemplate?: {
    include_header?: boolean
    include_footer?: boolean
  }
  generateTemplateData?(job: JobT, document: DocumentT, company: CompanyT, client: ClientT): object
}



/**
 *
 * @param lineItems
 */
const parseEstimateLineItems = (job: JobT, company: CompanyT, lineItems: Array<EstimateLineItemT>) => {
  if (!_.isArray(lineItems)) {
    return []
  }
  const companyVariables = company && company.variables ? { ...VariablesObj, ...company.variables } : VariablesObj

  let items = []
  lineItems.map((item, index) => {
    let tempItem = copyObject(item)
    if (companyVariables[item.item]) {


      tempItem.lineItemDate = item.lineItemDate != '' ? item.lineItemDate : job.date
      tempItem.item = companyVariables[item.item].verboseName;

      // fix label rate
      let unitRate = reflectorLabelsEstimate(companyVariables, companyVariables[item.item], 'rate')
      let rate = `$${parseFloat(`${item.rate}`).toFixed(2)}`;
      // split label $/mile to array($','mile')
      let splitUnitRateRate = unitRate.split("/")
      if (splitUnitRateRate.length >= 2) {
        rate = `${splitUnitRateRate[0]}${parseFloat(`${item.rate}`).toFixed(2)}/${splitUnitRateRate[1]}`
      }
      tempItem.rate = rate

      tempItem.units = `${item.units} ${reflectorLabelsEstimate(companyVariables, companyVariables[item.item], 'units')}`
      tempItem.total = `$${numberToCurrency(`${item.total}`, ".", ",", 2)}`;
    }

    items.push(tempItem)
  })
  return items;
}


const ConfigDocuments: Array<ConfigDocumentsT> = [
  {
    name: 'estimate',
    title: 'Estimate',
    display: [
      {
        "jobType": 'moving_labor',
        "state": ["all"]
      },
      {
        "jobType": 'intrastate_local',
        "state": ["all"]
      },
      {
        "jobType": 'intrastate_long',
        "state": ["all"]
      },
      {
        "jobType": 'international',
        "state": ["all"]
      },
      {
        "jobType": 'interstate',
        "state": ["all"]
      },
    ],
    variables: [
      {
        key: 'dirty',
        type: "boolean",
        value: false
      },
      {
        key: 'lineItems',
        type: "array",
        value: [
          {
            item: 'hourlyRateOne',
            lineItemDate: '',
            rate: VariablesObj.hourlyRateOne.value,
            total: VariablesObj.hourlyRateOne.value,
            units: 1
          }
        ]
      }
    ],
    defaultAgreement: {
      type: 'acknowledgement',
      clause: 'I acknowledge that I have been given a copy of this estimate to keep for my records.',
      content: null,
      timestamp: null,
      ip: null,
      userAgent: null,
    },
    template: "Estimate",

  },
  {
    name: 'invoice',
    title: 'Invoice',
    display: [
      {
        "jobType": 'moving_labor',
        "state": ["all"]
      },
      {
        "jobType": 'intrastate_local',
        "state": ["all"]
      },
      {
        "jobType": 'intrastate_long',
        "state": ["all"]
      },
      {
        "jobType": 'international',
        "state": ["all"]
      },
      {
        "jobType": 'interstate',
        "state": ["all"]
      },
    ],
    variables: [
      {
        key: 'dirty',
        type: "boolean",
        value: false
      },
      {
        key: 'client',
        type: 'object',
        value: {
          firstName: 'Tom',
          lastName: 'Client'
        }
      },
      {
        key: 'lineItems',
        type: "array",
        value: [
          {
            item: 'hourlyRateOne',
            lineItemDate: '',
            rate: VariablesObj.hourlyRateOne.value,
            total: VariablesObj.hourlyRateOne.value,
            units: 1
          }
        ]
      }
    ],
    template: "Invoice",
    optionsTemplate: {
      include_header: false
    },
    generateTemplateData: (job: JobT, document: DocumentT, company: CompanyT, client: ClientT) => {
      const lineItems = getVariableValue('lineItems', document.variables)
      const lineItemsN = parseEstimateLineItems(job, company, lineItems);
      const total = parseFloat(`${sumFinancialLineItems(lineItems)}`).toFixed(2)
      let mCompany = copyObject(company)
      mCompany.phone = phoneFormat(company.phone)
      let mClient = copyObject(client)
      mClient.phone = phoneFormat(client.phone)
      return {
        client: mClient,
        company: mCompany,
        lineItems: sortFinancialLineItems(lineItemsN),
        total: `${numberToCurrency(total, ".", ",", 2)}`
      }
    }
  },
  {
    name: 'receipt',
    title: 'Receipt',
    displayWithJobStatus: ['completed'],
    display: [
      {
        "jobType": 'moving_labor',
        "state": ["all"]
      },
      {
        "jobType": 'intrastate_local',
        "state": ["all"]
      },
      {
        "jobType": 'intrastate_long',
        "state": ["all"]
      },
      {
        "jobType": 'international',
        "state": ["all"]
      },
      {
        "jobType": 'interstate',
        "state": ["all"]
      },
    ],
    variables: [
      {
        key: 'dirty',
        type: "boolean",
        value: false
      },
      {
        key: 'client',
        type: 'object',
        value: {
          firstName: 'Tom',
          lastName: 'Client'
        }
      },
      {
        key: 'lineItems',
        type: "array",
        value: [
          {
            item: 'hourlyRateOne',
            lineItemDate: '',
            rate: VariablesObj.hourlyRateOne.value,
            total: VariablesObj.hourlyRateOne.value,
            units: 1
          }
        ]
      }
    ],
    template: "Receipt",
    optionsTemplate: {
      include_header: false
    },
    generateTemplateData: (job: JobT, document: DocumentT, company: CompanyT, client: ClientT) => {
      const invoce = _.cloneDeep(job?.documents?.invoice)
      const lineItems = getVariableValue('lineItems', invoce?.variables)
      const lineItemsN = parseEstimateLineItems(job, company, lineItems);
      const total = parseFloat(`${sumFinancialLineItems(lineItems)}`).toFixed(2)
      let mCompany = copyObject(company)
      mCompany.phone = phoneFormat(company.phone)
      let mClient = copyObject(client)
      mClient.phone = phoneFormat(client.phone)
      const sortItems = sortFinancialLineItems(lineItemsN)
     
      return {
        client: mClient,
        company: mCompany,
        lineItems: sortItems,
        total: `${numberToCurrency(total, ".", ",", 2)}`
      }
    }
  },
  {
    name: 'clientAgreement',
    title: 'Client Agreement',
    display: [
      {
        "jobType": 'moving_labor',
        "state": ["all"]
      },
      {
        "jobType": 'intrastate_local',
        "state": ["all"],
        'excludeState': ['Colorado']
      },
    ],
    variables: [
      {
        key: "estimate",
        type: "array",
        value: [],
      }
    ],
    defaultAgreement: {
      type: 'agreement',
      clause: 'I Agreed.',
      content: null,
      timestamp: null,
      ip: null,
      userAgent: null,
    },
    template: "ClientAgreement",

    generateTemplateData: function (job: JobT, document: DocumentT, company: CompanyT, client: ClientT) {
      let estimate = getVariableValue('estimate', document.variables)
      let lineItems: Array<EstimateLineItemT> = estimate ? getVariableValue('lineItems', estimate) : []
      const { stateMeta } = company
      const samePrimaryPuc = stateMeta && stateMeta.Colorado && stateMeta.Colorado.pucAddress && !stateMeta.Colorado.samePrimaryPuc
      const mailingAddress = samePrimaryPuc ? stateMeta.Colorado.pucAddress : company.address
      let data = {
        client: client,
        company: {
          ...company, ...{
            mailingAddress: mailingAddress,
            pucNumber: company.stateMeta && company.stateMeta.Colorado && company.stateMeta.Colorado.pucNumber
          }
        },
        estimate: {
          lineItems: sortFinancialLineItems(parseEstimateLineItems(job, company, lineItems))
        },
      }
      return data
    }
  },
  {
    name: 'coloradoClientAgreement',
    title: 'Client Agreement',
    display: [
      {
        "jobType": 'intrastate_local',
        "state": ["Colorado"]
      },
      {
        "jobType": 'intrastate_long',
        "state": ["Colorado"],

      },
    ],
    variables: [
      {
        key: "cargoInsurance",
        type: "boolean",
        value: false,
      },
      {
        key: "optionValuation",
        type: "string",
        value: null,
      },
      {
        key: "valuation",
        type: "object",
        value: {
          coverage: null,
          deductible: null,
          name: null,
          premium: null
        },
      },
      {
        key: "valueOfShipment",
        type: "number",
        value: false,
      },
      {
        key: "estimate",
        type: "array",
        value: [],
      }
    ],
    defaultAgreement: {
      type: 'agreement',
      clause: 'I Agreed.',
      content: null,
      timestamp: null,
      ip: null,
      userAgent: null,
    },
    template: "ColoradoClientAgreement",

    generateTemplateData: function (job: JobT, document: DocumentT, company: CompanyT, client: ClientT) {
      let estimate = getVariableValue('estimate', document.variables)
      let lineItems = estimate ? getVariableValue('lineItems', estimate) : []
      let optionsValuation = getVariableValue('optionsValuation', document.variables)
      const { stateMeta } = company
      const samePrimaryPuc = stateMeta && stateMeta.Colorado && stateMeta.Colorado.pucAddress && !stateMeta.Colorado.samePrimaryPuc
      const mailingAddress = samePrimaryPuc ? stateMeta.Colorado.pucAddress : company.address
      let data = {
        client: client,
        company: {
          ...company, ...{
            mailingAddress: mailingAddress,
            pucNumber: company.stateMeta && company.stateMeta.Colorado && company.stateMeta.Colorado.pucNumber
          }
        },
        estimate: {
          lineItems: parseEstimateLineItems(job, company, lineItems)
        },
        optionsValuation: optionsValuation
      }
      return data
    }
  },
  {
    name: 'creditCardAuthorization',
    title: 'Credit Card Authorization',
    display: [
      /*{
          "jobType": 'moving_labor',
          "state": ["all"]
      },
      {
          "jobType": 'intrastate_local',
          "state": ["all"]
      },
      {
          "jobType": 'intrastate_long',
          "state": ["all"]
      },
      {
          "jobType": 'international',
          "state": ["all"]
      },
      {
          "jobType": 'interstate',
          "state": ["all"]
      },*/
    ],
    variables: [],
  },
  {
    name: 'consumerAdvisement',
    title: 'Consumer Advisement',
    display: [
      {
        "jobType": 'intrastate_local',
        "state": ["Colorado"]
      },
      {
        "jobType": 'intrastate_long',
        "state": ["Colorado"]
      },
    ],
    variables: [],
    defaultAgreement: {
      type: 'acknowledgement',
      clause: 'I acknowledge that I have been given a copy of this consumer advisement to keep for my records.',
      content: null,
      timestamp: null,
      ip: null,
      userAgent: null,
    },
    template: "ConsumerAdvisement",

    generateTemplateData: function (job: JobT, document: DocumentT, company: CompanyT, client: ClientT) {
      let estimate = getVariableValue('estimate', document.variables)
      let lineItems = estimate ? getVariableValue('lineItems', estimate) : []
      let agreement = document.agreement ? document.agreement : []
      let data = {
        agreed: agreement.find(agreement => { _.isEqual(agreement.content, document.variables) })
      }
      return data
    }
  },
  {
    name: 'cubeSheet',
    title: 'Cube Sheet',
    display: [
      {
        "jobType": 'intrastate_long',
        "state": ["all"]
      },
      {
        "jobType": 'international',
        "state": ["all"]
      },
      {
        "jobType": 'interstate',
        "state": ["all"]
      },
    ],
    template: "CubeSheet",

    variables: [],
    generateTemplateData: (job: JobT, document: DocumentT, company: CompanyT, client: ClientT) => {
      let lineItems = getVariableValue('lineItems', document.variables)

      const finalLineItems = prepareCupeSheetForPrint(lineItems)

      const total = parseFloat(`${sumFinancialLineItems(_.cloneDeep(finalLineItems))}`).toFixed(2)
      let cloneCompany = _.cloneDeep(company)
      cloneCompany.phone = phoneFormat(company.phone)
      let mClient = copyObject(client)
      mClient.phone = phoneFormat(client.phone)
      return {
        // client: mClient,
        // company: cloneCompany,
        lineItems: finalLineItems,
        total: `${numberToCurrency(total, ".", ",", 2)}`,
        totalPounds: `${Number(total) * 7}`
      }
    }
  },
  {
    name: 'inventorySheet',
    title: 'Inventory Sheet',
    display: [
      {
        "jobType": 'intrastate_long',
        "state": ["all"]
      },
      {
        "jobType": 'international',
        "state": ["all"]
      },
      {
        "jobType": 'interstate',
        "state": ["all"]
      },
    ],
    variables: [],
    // template: 'InventorySheet',
  },
  {
    name: 'billOfLading',
    title: 'Bill of Lading',
    display: [

      {
        "jobType": 'intrastate_long',
        "state": ["all"]
      },
      {
        "jobType": 'international',
        "state": ["all"]
      },
      {
        "jobType": 'interstate',
        "state": ["all"]
      },
    ],
    variables: [
      {
        key: "optionEstimate",
        type: "string",
        value: null,
      },

      {
        key: "optionValuation",
        type: "string",
        value: null,
      },
      {
        key: "packingMaterials",
        type: "array",
        value: [],
      }
    ],
    template: "BillOfLading",
    generateTemplateData: (job: JobT, document: DocumentT, company: CompanyT, client: ClientT) => {
      let optionEstimate = getVariableValue('optionEstimate', document.variables)
      let optionValuation = getVariableValue('optionValuation', document.variables)
      let packingMaterials = getVariableValue('packingMaterials', document.variables)

      const getTotal = (lineItems) => {
        if (_.isArray(lineItems)) {
          return lineItems.reduce((perAmount, item, index) => {
            return Number(perAmount) + (Number(item.quantity) * Number(item.rate))
          }, 0)
        }
        return 0
      }

      let cloneCompany = _.cloneDeep(company)
      cloneCompany.phone = phoneFormat(company.phone)
      let mClient = copyObject(client)
      mClient.phone = phoneFormat(client.phone)
      return {
        // client: mClient,
        // company: cloneCompany,
        optionEstimate: optionEstimate,
        optionValuation: optionValuation,
        packingMaterials: packingMaterials,
        total: `${numberToCurrency(getTotal(packingMaterials), ".", ",", 2)}`

      }
    }
  },
  {
    name: 'consumerRights',
    title: 'Consumer Rights',
    display: [

      {
        "jobType": 'intrastate_long',
        "state": ["all"]
      },
      {
        "jobType": 'international',
        "state": ["all"]
      },
      {
        "jobType": 'interstate',
        "state": ["all"]
      },
    ],
    variables: [],
    template: "consumerRights",
  },
]

// 'Cube Sheet',
//     'Inventory Sheet',
//     'Bill of Lading',
//     'Credit Card Authorization',
//     'Consumer Rights'


export const filterDocuments = (jobType: JobTypeTStrings, jobStatus: JobStatusTStrings, state: string | null): Array<ConfigDocumentsT> => {
  // let documents = []
  let documents = ConfigDocuments.filter((x) => {
    let jobTypeFind = x.display.find((item,) => {
      if (item.jobType == jobType
        && (item.state.includes('all') || item.state.includes(state))
        && (!item.excludeState || (item.excludeState && !item.excludeState.includes(state)))
        && (!_.isArray(x?.displayWithJobStatus) || x.displayWithJobStatus.includes(jobStatus))
      ) {
        return item;
      }
    })
    if (jobTypeFind) {
      return x;
    }
    // console.log("filterDocuments", x.name)
  })

  return documents;
}
